import removeModels from './removeModels'

export default { removeModels }
